import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Table, Card, Col, Form, Row } from "react-bootstrap";
import { IconPlus } from "@tabler/icons-react";
import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import DynamicPagination from "../../components/DynamicPagination ";
import moment from "moment";
import { useFormContext, useFieldArray } from "react-hook-form";
import { toast } from "react-toastify";
import { trimTrailingZeros } from "../../utils/_helpers";
function SearchPopUpSales({
  ordertype,
  show,
  setShow,
  onAddSku,
  searchProps,
  setSearchProps,
  setCardSearch,
  cardSearch,
  calculateCosts,
  updateTextArea,
  order_ref_type,
  syncProductSalesWithCards,
  searchType,
  appendSkuToArray,
}) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [fetchedData, setFetchedData] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const [searchDebounce, setSearchDebounce] = useState({
    searchSku: "",
    vendor_id: "",
    type: "",
  });

  const { data: vendorlist, postData: fetchVendorList } = usePostRequest(
    API_ENDPOINTS.GET_VENDORS,
  );

  useEffect(() => {
    fetchVendorList({ page: 1, limit: 500, is_relevent: true });
  }, []);

  const handleVendorFilter = (e) => {
    setSearchDebounce((prev) => ({ ...prev, vendor_id: e.target.value }));
    setPage(1);
  };

  const handleTypeFilter = (e) => {
    setSearchDebounce((prev) => ({ ...prev, type: e.target.value }));
    setPage(1);
  };

  // console.log("searchType", searchType);

  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (searchProps) {
      setSearchDebounce({
        searchSku: searchProps.searchSku || "",
        productName: searchProps.productName || "",
        searchDescription: searchProps.searchDescription || "",
        searchVendor: searchProps.searchVendor || "",
        contract_type: searchProps.ContractName || "",
        project_opportunity: searchProps.project_opportunity || "",
      });
    }
  }, [searchProps]);

  const vehicleId = watch("vehicleId");
  const handleAddClick = (product) => {
    // console.log("productss", product);

    const currentValues = getValues("product_sales") || [];
    const isDuplicate = currentValues.some(
      (item, idx) =>
        item?.rowId === product?.raw_sku_id && idx !== searchProps.indexIs,
    );
    if (isDuplicate) {
      toast.error(
        `Product with SKU ${product.sku_display_name} already exists.`,
      );
      return;
    }
    console.log("ye undef waala chla", searchProps.indexIs);
    if (searchProps.indexIs !== undefined) {
      // const skuIdUnique = getValues(
      //   `product_sales[${searchProps.indexIs}].rowId`
      // );
      // console.log("abcdefgh");
      // appendSkuToArray(product, 1, skuIdUnique);
      const currentOriginalVendors = getValues("originalVendors") || {};
      setValue("originalVendors", {
        ...currentOriginalVendors,
        [searchProps.indexIs]: product?.Vendor?.display_name,
      });

      // Null vendor case
      // if (product?.Vendor === null) {
      //   console.log(
      //     "Product vendor is null. Here's the product data new console:",
      //     product
      //   );
      //   setVendorSkuId(product?.sku_id);
      //   setShowVendorPopup(true);
      //   setSelectedProduct(product);
      //   return;
      // }
      setValue(`product_sales[${searchProps.indexIs}].clin`, product?.clin_id, {
        shouldValidate: true,
      });
      setValue(
        `product_sales[${searchProps.indexIs}].cost`,
        trimTrailingZeros(product?.aspetto_price),
        { shouldValidate: true },
      );
      setValue(
        `product_sales[${searchProps.indexIs}].productName`,
        product?.name,
        { shouldValidate: true },
      );
      setValue(
        `product_sales[${searchProps.indexIs}].vendorPartner`,
        product?.Vendor?.display_name,
        { shouldValidate: true },
      );

      setValue(
        `product_sales[${searchProps.indexIs}].vendorId`,
        product?.Vendor?.id,
        {
          shouldValidate: true,
        },
      );

      setValue(`product_sales[${searchProps.indexIs}].skuLocked`, true, {
        shouldValidate: true,
      });

      setValue(
        `product_sales[${searchProps.indexIs}].productId`,
        product?.Product?.id ?? product?.id,
        {
          shouldValidate: true,
        },
      );

      const contractVehicletype = watch("contractVehicletype");
      console.log("contractVehicletype", contractVehicletype);
      // check if product-bound
      if (contractVehicletype?.split(",").includes("product-bound")) {
        const rowId = product?.raw_sku_id;
        setValue(
          `product_sales[${searchProps.indexIs}].max_quantity`,
          product?.max_quantity,
          {
            shouldValidate: true,
          },
        );
        setValue(
          `product_sales[${searchProps.indexIs}].rowId`,
          product?.raw_sku_id,
          {
            shouldValidate: true,
          },
        );
        appendSkuToArray(product, 1, rowId);
        console.log("ye bhaag rha h", rowId);
      } else {
        const skuIdUnique = getValues(
          `product_sales[${searchProps.indexIs}].rowId`,
        );
        console.log("abcdefgh", skuIdUnique);
        appendSkuToArray(product, 1, skuIdUnique);
      }

      setValue(
        `product_sales[${searchProps.indexIs}].skuIdUnique`,
        product?.sku_id,
        {
          shouldValidate: true,
        },
      );
      setValue(
        `product_sales[${searchProps.indexIs}].skuId`,
        product?.sku_display_name,
        {
          shouldValidate: true,
        },
      );

      setValue(`product_sales[${searchProps.indexIs}].type`, product?.type);

      setValue(
        `product_sales[${searchProps.indexIs}].skuDescription`,
        product?.description_sales,
        { shouldValidate: true },
      );

      setValue(
        `product_sales[${searchProps.indexIs}].prodDescription`,
        product?.description,
        { shouldValidate: true },
      );

      setValue(
        `product_sales[${searchProps.indexIs}].purchaseDescription`,
        product?.description,
        { shouldValidate: true },
      );

      if (updateTextArea && searchProps.indexIs !== undefined) {
        updateTextArea(searchProps.indexIs, product?.description);
      }

      setValue(
        `product_sales[${searchProps.indexIs}].um`,
        product?.uoi ?? "EA",
        {
          shouldValidate: true,
        },
      );

      setValue(`product_sales[${searchProps.indexIs}].qty`, 1);
      setValue(
        `product_sales[${searchProps.indexIs}].customerCost`,
        product?.customer_price,
        { shouldValidate: true },
      );

      if (product?.customer_price == "0.00") {
        setValue(`product_sales[${searchProps.indexIs}].margin`, "8", {
          shouldValidate: true,
        });
      }
      // setValue(
      //   `product_sales[${searchProps.indexIs}].margin`,
      //   product?.margin_percent,
      //   { shouldValidate: true }
      // );

      const updatedCardSearch = [...cardSearch];
      updatedCardSearch[searchProps.indexIs] = {
        ...updatedCardSearch[searchProps.indexIs],
        showSuggestions: false,
      };
      setCardSearch(updatedCardSearch);
      calculateCosts();
      toast.success(
        `Product ${product.sku_display_name} is added successfully`,
      );
      syncProductSalesWithCards();
      if (
        !searchProps.searchSku &&
        !searchProps.productName &&
        !searchProps.searchDescription &&
        !searchProps.searchVendor
      ) {
        // console.log("first");
        const updatedCards = getValues("product_sales");
        const nextBlankIndex = updatedCards.findIndex(
          (card) => !card.skuIdUnique && !card.cost && !card.skuDescription,
        );
        setSearchProps({
          searchSku: "",
          searchDescription: "",
          productName: "",
          searchVendor: "",
          ContractName: searchProps.ContractName
            ? searchProps.ContractName
            : "",
          indexIs: nextBlankIndex !== -1 ? nextBlankIndex : undefined,
        });
      }
    } else {
      // console.log("else case clha")
      onAddSku(product);
      syncProductSalesWithCards();
    }
    // toast.success(`Product ${product.sku_id} is added successfully`);
  };

  const handleSKUSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchSku: e.target.value,
    }));
    setPage(1);
  };
  const handleDescriptionSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchDescription: e.target.value,
    }));
  };

  const handleProductSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      productName: e.target.value,
    }));
  };

  const handleContractSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      contract_type: e.target.value,
    }));
  };
  const handleRfqidSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      project_opportunity: e.target.value,
    }));
  };

  const handleVendorSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchVendor: e.target.value,
    }));
  };

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setLimit(selectedLimit);
  };

  const { debounceSearch } = useDebounce(searchDebounce);

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION,
  );

  // console.log("data", data);

  const { postData: fetchContractProduct, data: dataContract } = usePostRequest(
    API_ENDPOINTS.GET_PRODUCTS,
  );

  const contractVehicletype = watch("contractVehicletype");

  useEffect(() => {
    setFetchedData(null);
    setSelectedVendor(null);
    const shouldAddContractType = contractVehicletype
      ?.split(",")
      .includes("product-bound");

    // console.log("shouldAddContractType", shouldAddContractType)
    // console.log("vehicleId", vehicleId)

    if (searchType === "skuAll") {
      fetchProductSearch({
        page,
        limit,
        order_status: ordertype,
        module_type: "ORDER",
        vendor_id: searchDebounce?.vendor_id || null,
        type: searchDebounce?.type || undefined,
        search: searchDebounce?.searchSku || null,
        ...(shouldAddContractType && { contract_type_id: vehicleId }),
        project_id:
          (order_ref_type === "project" || order_ref_type === "opportunity") &&
          searchDebounce?.project_opportunity?.length > 0
            ? searchDebounce.project_opportunity
            : undefined,
      });
    } else if (searchType === "contract") {
      fetchContractProduct({
        module_type: "ORDER",
        page,
        limit,
        contract_type_id: vehicleId,
        vendor_id: searchDebounce?.vendor_id || null,
        type: searchDebounce?.type || undefined,
        search: searchDebounce?.searchSku || null,
        ...(shouldAddContractType && { contract_type_id: vehicleId }),
      });
    } else {
      fetchProductSearch({
        page,
        limit,
        order_status: ordertype,
        module_type: "ORDER",
        vendor_id: searchDebounce?.vendor_id || null,
        type: searchDebounce?.type || undefined,
        search: searchDebounce?.searchSku || null,
        ...(shouldAddContractType && { contract_type_id: vehicleId }),
        project_id:
          (order_ref_type === "project" || order_ref_type === "opportunity") &&
          searchDebounce?.project_opportunity?.length > 0
            ? searchDebounce.project_opportunity
            : undefined,
      });
    }
  }, [page, limit, searchDebounce]);

  useEffect(() => {
    if (data && data.data) {
      setFetchedData(data);
    }
  }, [data]);

  useEffect(() => {
    if (dataContract && dataContract.data) {
      setSelectedVendor(dataContract);
    }
  }, [dataContract]);

  const handleCloseModal = () => {
    setShow(false);
    setSearchDebounce({
      searchSku: "",
      productName: "",
      searchDescription: "",
      searchVendor: "",
      contract_type: "",
    });
    setFetchedData(null);
  };

  return (
    <>
      <Modal
        scrollable={true}
        show={show}
        onHide={handleCloseModal}
        className="skusearch"
        dialogClassName="modal-90vw"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Row className="w-100">
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search"
                autoComplete="off"
                value={searchDebounce.searchSku}
                onChange={handleSKUSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Select
                value={searchDebounce.vendor_id}
                onChange={handleVendorFilter}
              >
                <option value="">All Vendors</option>
                {vendorlist?.data?.map((vendor) => (
                  <option
                    key={vendor.VendorContact?.vendor_id}
                    value={vendor.VendorContact?.vendor_id ?? 0}
                  >
                    {vendor.display_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col className="mb-3">
              <Form.Select
                value={searchDebounce.type}
                onChange={handleTypeFilter}
              >
                <option value="">All Types</option>
                <option value="inventory">Inventory</option>
                <option value="non-inventory">Non-Inventory</option>
                <option value="kit">Kit</option>
              </Form.Select>
            </Col>
          </Row>
        </Modal.Header>

        <Modal.Body className="vh-100">
          <div className="table-responsive">
            <Table>
              <thead responsive>
                <tr>
                  <th></th>
                  <th className="">VENDOR</th>
                  <th className="">SKU</th>
                  <th className="">PRODUCT NAME</th>
                  <th className="">TYPE</th>
                  <th className="">DESCRIPTION</th>
                  {/* <th className="text-center">COST</th> */}
                </tr>
              </thead>
              {searchType === "contract" ? (
                <tbody>
                  {selectedVendor &&
                    selectedVendor?.data?.map((product, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span
                              onClick={() => handleAddClick(product)}
                              className="avatar bg-green-lt"
                            >
                              <IconPlus />
                            </span>
                          </td>
                          <td className="text-start">
                            {product?.Vendor?.display_name}
                          </td>
                          <td className="text-start text-orange">
                            {product?.sku_display_name}
                          </td>
                          <td className="text-start text-orange">
                            {product?.name}
                          </td>
                          <td className="text-start">
                            {{
                              kit: "Kit",
                              "non-inventory": "Non-Inventory",
                              inventory: "Inventory",
                            }[product?.type] || ""}
                            {product?.kit_type ? ` (${product.kit_type})` : ""}
                          </td>
                          <td className="text-start">
                            {product?.description?.length > 100
                              ? product.description_sales.slice(0, 100) + "..."
                              : product.description_sales}
                          </td>

                          {/* <td className="text-center">
                            {trimTrailingZeros(product?.aspetto_price)}
                          </td> */}
                        </tr>
                      );
                    })}
                </tbody>
              ) : (
                <tbody>
                  {fetchedData &&
                    fetchedData?.data?.map((product, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span
                              onClick={() => handleAddClick(product)}
                              className="avatar bg-green-lt"
                            >
                              <IconPlus />
                            </span>
                          </td>
                          <td className="text-start">
                            {product?.Vendor?.display_name}
                          </td>
                          <td className="text-start text-orange">
                            {product?.sku_display_name}
                          </td>
                          <td className="text-start text-orange">
                            {product?.name}
                          </td>
                          <td className="text-start">
                            {{
                              kit: "Kit",
                              "non-inventory": "Non-Inventory",
                              inventory: "Inventory",
                            }[product?.type] || ""}
                            {product?.kit_type ? ` (${product.kit_type})` : ""}
                          </td>
                          <td className="text-start">
                            {product?.description_sales
                              ? product.description_sales.length > 100
                                ? product.description_sales.slice(0, 100) +
                                  "..."
                                : product.description_sales
                              : ""}
                          </td>

                          {/* <td className="text-center">
                            {trimTrailingZeros(product?.aspetto_price)}
                          </td> */}
                        </tr>
                      );
                    })}
                </tbody>
              )}
            </Table>
          </div>

          {searchType === "contract" ? (
            dataContract?.data?.length > 0 ? (
              <DynamicPagination
                totalPages={selectedVendor?.pagination?.totalPages}
                currentPage={page}
                onPageChange={handlePageChange}
                limitPerPage={limit}
                onLimitChange={handleLimitChange}
              />
            ) : (
              <p className="text-center mt-2">No matching records found.</p>
            )
          ) : data?.data?.length > 0 ? (
            <DynamicPagination
              totalPages={data?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
            />
          ) : (
            <p className="text-center mt-2">No matching records found.</p>
          )}

          {/* {searchType === "contract" && dataContract?.data?.length > 0 ? (
            <DynamicPagination
              totalPages={selectedVendor?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
            />
          ) : data?.data?.length > 0 ? (
            <DynamicPagination
              totalPages={data?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
            />
          ) : null} */}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SearchPopUpSales;
